// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/loader/stylesheet/spinner.scss
 ** module id = 412
 ** module chunks = 1
 **/